module.exports = __webpack_public_path__ + "img/17.0623c3dd.png";